<template>
  <div class="widget-summary">
    <div class="card">
      <div class="card-header">
        <h5>
          Avui {{ new Date().toLocaleDateString() }}
        </h5>
      </div>
      <div class="card-body" style="background-color:#EAEAF1">
        <div class="subtitulo" style="text-align: left; padding: 15px 20px; font-size: 15px; background-color: rgb(0, 115, 207); font-weight:bold; color:#fff">
            Resum escales
        </div>
        <table>
          <tr v-for="(item, index) in getValues" :key="index">
            <td class="icon-col">
                <div class="img-icon" v-if="item[0] == 'creuers'">
                  <Creuers />
                </div>
                <div class="img-icon" v-if="item[0] == 'tanquers'">
                  <Tanquers />
                </div>
                <div class="img-icon" v-if="item[0] == 'portacontenidors'">
                  <Portacontenidors />
                </div>
                <div class="img-icon" v-if="item[0] == 'transbordadors'">
                  <Ferris />
                </div>
                <div class="img-icon" v-if="item[0] == 'portavehicles'">
                  <Carcarrier />
                </div>
                <div class="img-icon" v-if="item[0] == 'granelers'">
                  <Granelers />
                </div>
                <div class="img-icon" v-if="item[0] == 'carregaroro'">
                  <Carregaroro />
                </div>
                <div class="img-icon" v-if="item[0] == 'carregalolo'">
                  <Lolo />
                </div>
                <div class="img-icon" v-if="item[0] == 'petroliers'">
                  <Petroliers />
                </div>
                <div class="img-icon" v-if="item[0] == 'altres'">
                  <Altres />
                </div>
            </td>
            <td class="col-number">
              <h3>
                {{ item[1] }}
              </h3>
            </td>
            <td v-if="index != 'bgcolor' && index != 'data'">
              <h3>{{ getRealName(item[0]) }}</h3>
            </td>
            <td>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Creuers from './Icons/Creuers.vue';
import Tanquers from './Icons/Tanquers.vue';
import Portacontenidors from './Icons/Portacontenidors.vue';
import Ferris from './Icons/Ferris.vue';
import Carcarrier from './Icons/Carcarrier.vue';
import Granelers from './Icons/Granelers.vue';
import Carregaroro from './Icons/Carregaroro.vue';
import Lolo from './Icons/Lolo.vue';
import Altres from './Icons/Altres.vue';
import Petroliers from './Icons/Petrolers.vue';
export default {
  name: 'Summary',
  props: {
    data: Array
  },
  components: { Petroliers, Altres, Creuers, Tanquers, Portacontenidors, Ferris, Carcarrier, Granelers, Carregaroro, Lolo },
  computed: {
    getValues: function(){
      const items = Object.entries(this.data[0].vars).filter(item => item[0] != 'bgcolor' && item[0] != 'data')
      return { ...items }
    }
  },
  methods: {
    getRealName(title){
  
      if(title == 'carregaroro'){
        return 'Càrrega Ro-Ro'
      }else if(title == 'carregalolo'){
        return 'Càrrega Lo-Lo'
      }
      else if(title == 'transbordadors'){
        return 'Ferris'
      }
      else {
        return title.charAt(0).toUpperCase() + title.slice(1)
      }

    }
  }
}
</script>